module.exports = __webpack_public_path__ + "img/ep-G.05442151.jpg";